import React from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { DetailList } from '@tecuity/granite-ui/DetailList'
import { openSpecificImage } from '../ImageViewer/ImageViewerActions'
import { PUT } from '../../requests'

import format from 'date-fns/format'
import './RecordDetailsPage'
import { Spinner } from '../Loaders/Loaders'

const GenericDetails = ({
  activeTabId,
  record,
  beforeChildren = null,
  config = { DetailCards: [], FieldSettings: {} },
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = React.useState('')
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)

  const ReadFieldSetting = (key, fieldSetting, value) => {
    return {
      label: fieldSetting.DisplayName,
      value: ReadValue(
        key,
        fieldSetting.FieldType,
        value,
        fieldSetting.EditApiCall,
        fieldSetting.EditPermissions,
        fieldSetting.DisplayName,
      ),
    }
  }

  const callApi = (key, apiCall, value) => {
    setLoading(key)
    let url = apiCall
      .replace(
        '{recordNum}',
        window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
      )
      .replace('{value}', value)
    PUT(
      url,
      (response) => {
        record[key] = value
        setLoading('')
      },
      (error) => {
        console.error(`error calling endpoint ${url}, with error : ${error}`)
      },
    )
  }

  const ReadValue = (key, fieldType, value, editApiCall, editPermissions, name) => {
    let curratedValue = value || value === false ? value : 'N/A'
    if (loading === key) {
      return <Spinner size="small" themeColor="dark-neutral" />
    } else {
      switch (fieldType) {
        case 0:
          break
        case 2:
          return ReadAddress(curratedValue)
        case 4:
          return value ? format(new Date(curratedValue), 'MM/dd/yyyy') : curratedValue
        case 16:
          return value ? value.Name : ''
        case 32:
          return (
            <Checkbox
              checked={value}
              disabled={
                !(
                  editApiCall &&
                  editPermissions &&
                  editPermissions.every((e) => appUserRights.includes(e))
                )
              }
              ariaLabel={name}
              onClick={(e) => callApi(key, editApiCall, e.target.checked)}
            />
          )
        case 64:
          return value ? 'Good' : 'Not Good'
        case 128:
          return value
        case 256:
          return <p style={{ color: value.Color }}>{value.Name}</p>
        case 512:
          return (
            <div
              className="dlnTableLink"
              onClick={() => OpenImageViewer(value.ImageEnvelopeId, value.ImageNum)}
              style={{ color: value.Color }}
            >
              {value.ImageNum}
            </div>
          )
        case 1024:
          return (
            <div
              className="dlnTableLink"
              onClick={() =>
                history.push(value.path + (value.appendValue ? `/${value.value}` : ''))
              }
            >
              {value.value}
            </div>
          )
        default:
          console.error('Uncertain Field Type: ' + fieldType + ' for value: ' + value)
          break
      }
      return value
    }
  }

  const OpenImageViewer = (ImageEnvelopeId, ImageNum) => {
    dispatch(openSpecificImage(ImageEnvelopeId, ImageNum))
  }

  const ReadAddress = (address = {}) => {
    const showNewLine =
      (address.AddressLine1 || address.AddressLine2 || address.AddressLine3) &&
      (address.City || address.StateOrProvince || address.PostalCode || address.Country)
    return (
      (address.AddressLine1 ? address.AddressLine1 : '') +
      (showNewLine ? '\n' : '') +
      (address.AddressLine2 ? address.AddressLine2 + '\n' : '') +
      (address.AddressLine3 ? address.AddressLine3 + '\n' : '') +
      (address.City ? address.City + ',' : '') +
      (address.StateOrProvince ? (address.City ? ' ' : '') + address.StateOrProvince : '') +
      (address.PostalCode
        ? (address.City || address.StateOrProvince ? ' ' : '') + address.PostalCode
        : '') +
      (address.Country
        ? (address.City || address.StateOrProvince || address.PostalCode ? ' ' : '') +
          address.Country
        : '')
    )
  }

  const BuildSubCard = (contentList, title, i) => {
    return (
      <DetailCard
        key={i}
        label={`${title} (${i + 1})`}
        className="sub-card"
        customCss={{ width: '100%', maxWidth: '400px' }}
      >
        <DetailList key={i} className="detailsList" details={contentList} />
      </DetailCard>
    )
  }

  const BuildCardContents = (cardOrder, record, recordFieldSettings) => {
    let contentList = []
    let contentList2 = []
    let isParent = false
    let subCardList = []

    Object.keys(recordFieldSettings).forEach((key) => {
      if (
        recordFieldSettings[key] &&
        recordFieldSettings[key].CardNumber === cardOrder &&
        (recordFieldSettings[key].Enabled || recordFieldSettings[key].IsEnabled)
      ) {
        isParent = recordFieldSettings[key].IsParent
        if (isParent) {
          if (record[key].length) {
            record[key].forEach((field, i) => {
              // let fieldToMap
              let subContentList = []
              Object.keys(recordFieldSettings[key].Fields).forEach((subkey, i) => {
                // fieldToMap = subkey
                if (
                  recordFieldSettings[key].Fields[subkey].Enabled ||
                  recordFieldSettings[key].Fields[subkey].IsEnabled
                ) {
                  subContentList.push(
                    ReadFieldSetting(key, recordFieldSettings[key].Fields[subkey], field[subkey]),
                  )
                }
              })
              subCardList.push({ title: key, contentList: subContentList })
            })
          }
        } else {
          if (recordFieldSettings[key].Column === 0) {
            contentList.push(ReadFieldSetting(key, recordFieldSettings[key], record[key]))
          } else {
            contentList2.push(ReadFieldSetting(key, recordFieldSettings[key], record[key]))
          }
        }
      }
    })

    return isParent ? (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'space-evenly',
        }}
      >
        {(subCardList || []).map((card, i) => BuildSubCard(card.contentList, card.title, i))}
      </div>
    ) : (
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        {contentList.length > 0 && <DetailList className="detailsList" details={contentList} />}
        {contentList2.length > 0 && <DetailList className="detailsList" details={contentList2} />}
        {contentList.length === 0 && contentList2.length === 0 ? "Configuration logic does not show any details in this card." : null}
      </div>
    )
  }

  return (
    <div
      className="row"
      style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginBottom: '20px' }}
    >
      {beforeChildren}
      {(config.DetailCards || [])
        .filter((card) => (activeTabId ? card.Tab === activeTabId : !card.Tab))
        .map((card) => {
          return (
            <DetailCard key={card.Order} className="detailsCard" label={card.Title}>
              {BuildCardContents(card.Order, record, config.FieldSettings)}
            </DetailCard>
          )
        })}
    </div>
  )
}

export default GenericDetails
